import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../service";
import { IAcademicPositionsCreate, IAcademicPositionsPayload } from "../types";
import { IErrorResponse, IRootState } from "../../../../types";
import {
    deletedAcademicPositions,
    deletedRestoreAcademicPositions,
    setAcademicPositions,
    setAcademicPositionsRestore,
    updateAcademicPositions,
} from "./academicPositionsSlice";

const SetAcademicPositions = createAsyncThunk(
    "create/academic/positions",
    async (data: IAcademicPositionsCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/positions", data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetAcademicPositions = createAsyncThunk(
    "get/academic/positions",
    async (_, { dispatch, rejectWithValue, getState }) => {
        try {
            const response = await request.get("/positions");
            const lang = getState() as IRootState;
            const defaultLanguage = lang.languages.defaultLanguage;
            dispatch(setAcademicPositions({ data: response.data, defaultLanguage }));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteAcademicPositions = createAsyncThunk(
    "delete/academic/positions",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.delete(`/positions/${id}`);

            dispatch(deletedAcademicPositions(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditAcademicPositions = createAsyncThunk(
    "edit/academic/positions",
    async (data: IAcademicPositionsPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/positions/${data.id}`, data);
            dispatch(updateAcademicPositions(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeletePositions = createAsyncThunk(
    "get/delete/academic/positions",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.get(`/positions/deleted-items`);
            dispatch(setAcademicPositionsRestore(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const RestoreDeletePositions = createAsyncThunk(
    "restore/delete/academic/positions",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/positions/restore/${id}`);

            dispatch(deletedRestoreAcademicPositions(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export {
    GetAcademicPositions,
    DeleteAcademicPositions,
    EditAcademicPositions,
    SetAcademicPositions,
    RestoreDeletePositions,
    GetDeletePositions,
};
